var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 23.25C19.1 23.25 21.2751 22.5902 23.1252 21.354C24.9752 20.1179 26.4172 18.3609 27.2686 16.3052C28.1201 14.2495 28.3429 11.9875 27.9088 9.80524C27.4748 7.62295 26.4033 5.6184 24.83 4.04505C23.2566 2.47171 21.2521 1.40025 19.0698 0.966171C16.8875 0.532087 14.6255 0.754874 12.5698 1.60636C10.5141 2.45785 8.75713 3.89979 7.52097 5.74984C6.2848 7.59989 5.625 9.77497 5.625 12V17.8125L2.25 14.4375L0.9375 15.75L6.5625 21.375L12.1875 15.75L10.875 14.4375L7.5 17.8125V12C7.5 10.1458 8.04983 8.33325 9.07997 6.79154C10.1101 5.24982 11.5743 4.04821 13.2873 3.33863C15.0004 2.62906 16.8854 2.44341 18.704 2.80514C20.5225 3.16688 22.193 4.05976 23.5041 5.37088C24.8152 6.682 25.7081 8.35246 26.0699 10.171C26.4316 11.9896 26.2459 13.8746 25.5364 15.5877C24.8268 17.3007 23.6252 18.7649 22.0835 19.795C20.5418 20.8252 18.7292 21.375 16.875 21.375V23.25Z",
    fill: "#FF914D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset_icon.131b0891a4de3087f8295f050ea1c50d.svg";
export { ForwardRef as ReactComponent };